import apiService from "../../api/api.service";
import { CallStartResponse } from "./callStart.types";

export interface CallStartParams {
  firstname?: string;
  lastname?: string;
  phone_number?: string;
}

export const fetchCallStart = (params?: CallStartParams) => {
  const timestamp = Date.now().toString();
  return apiService.get<CallStartResponse>("/call-start", {
    headers: { timestamp },
    params,
  });
};